import { GOOGLE_RECAPTCHA_SITE_KEY } from './constants'

export async function getRecaptchaToken(action) {
    return new Promise(async (res) => {
        try {
            if (!action) action = 'unknown';

            if (typeof process !== 'undefined' && process.env.NODE_ENV === 'development') return res('test');
            if (typeof grecaptcha === 'undefined') return res(null);
            const token = await grecaptcha.execute(GOOGLE_RECAPTCHA_SITE_KEY, { action: action.replace(/-/g, '') });

            if (token) return res(token);
            else return res(null);
        } catch (err) {
            console.error('Error in getRecaptchaToken:', err);
            return res(null);
        }
    })
}